module.exports = __webpack_public_path__ + "img/member.4022e63b.svg";